import styled from 'styled-components'
import dynamic from 'next/dynamic'

import FormSubmitButton from '../../form/FormSubmitButton'
import FormikForm from '../../form/FormikForm'
import { mq, sizes } from '../../theme'
import FormFieldInput from '../../form/fields/FormFieldInput'
import FormFieldDropdownSelect from '../../form/fields/FormFieldDropdownSelect'

const FormFieldAutoSuggest = dynamic(
  () => import('../../form/fields/FormFieldAutoSuggest')
)

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Form = styled(FormikForm)`
  width: 100%;
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media ${mq(sizes.mobile)} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 3rem;
    grid-row-gap: 2rem;
  }

  @media ${mq(sizes.tablet)} {
    gap: 3rem;
  }
`

export const CategorySelect = styled(FormFieldDropdownSelect)`
  @media ${mq(sizes.mobile)} {
    grid-area: 1 / 1 / 2 / 2;
  }
`

export const AutoSuggestField = styled(FormFieldAutoSuggest)``

export const SpecialitySelect = styled(FormFieldDropdownSelect)`
  @media ${mq(sizes.mobile)} {
    grid-area: 2 / 1 / 3 / 2;
  }
`

export const TermInput = styled(FormFieldInput)`
  @media ${mq(sizes.mobile)} {
    grid-area: 3 / 1 / 4 / 3;
  }
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBase};
  margin-bottom: 2.4rem;

  @media ${mq(sizes.tablet)} {
    margin-bottom: 4rem;
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 3.6rem auto 0 auto;
`

export const SubmitButton = styled(FormSubmitButton)``
